import { Guid } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicAvailableProductType } from '../enums/public-available-product-type';
import { PublicSales } from '@web/shared/module/shop';

export class PublicAvailableProduct {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      slug: string;
      type: PublicAvailableProductType;
      featuredFile: Multimedia;
      sales: PublicSales;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get type(): PublicAvailableProductType {
    return this.data.type;
  }

  public get featuredFile(): Multimedia {
    return this.data.featuredFile;
  }

  public get sales(): PublicSales {
    return this.data.sales;
  }
}
